export const SET_LOCALE = 'SET_LOCALE'
export const SET_RATE_USD = 'SET_RATE_USD'
